import {StepTestResult, TestPassState, TestQuestion, TestResponse, TestResponseCommands} from '@app/modules/diagnostics/components/diagnostics/diagnostic-items/models';
import {Observable, of} from 'rxjs';
import {delay} from 'rxjs/operators';

export abstract class Step {
  isHidden = false;
  testStatus: string;
  _isPreparedForTest = true;
  _stepPayload: any;
  testQuestion: TestQuestion;
  testResult: StepTestResult;
  needToPrepareBeforeTest: boolean;
  name: string;
  title: string;

  constructor(needToPrepareBeforeTest = false) {
    this.needToPrepareBeforeTest = needToPrepareBeforeTest;
    this.testResult = new StepTestResult();

    if (needToPrepareBeforeTest) {
      this.isPreparedForTest = false;
    }
  }

  set isPreparedForTest(value: boolean) {
    this._isPreparedForTest = value;
  }

  get isPreparedForTest(): boolean {
    return this._isPreparedForTest;
  }

  set stepPayload(value: any) {
    this._isPreparedForTest = true;
    this._stepPayload = value;
  }

  get stepPayload(): any {
    return this._stepPayload;
  }

  resetStep() {
    if (this.needToPrepareBeforeTest) {
      this.isPreparedForTest = false;
    }
    this.isHidden = false;
    this.testResult = new StepTestResult();
  }

  abstract doRunStep(): Observable<TestResponse>;

  runStep(): Observable<TestResponse> {
    if (!this._isPreparedForTest) {
      return of(new TestResponse(TestResponseCommands.REQUEST_QUESTION, this.testQuestion));
    } else {
      return this.doRunStep().pipe(delay(500));
    }
  };

  toString() {
    let stepMessage;

    switch (this.testResult.status) {
      case TestPassState.PENDING: {
        stepMessage = 'not accomplished.';
        break;
      }
      case TestPassState.PASSED: {
        stepMessage = this.testResult.text;
        break;
      }
      case TestPassState.FAILED: {
        stepMessage = this.testResult.text;
        break;
      }
    }

    return `${this.title} -- ${stepMessage}, `;
  }
}
